import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '@iarcpsu/emanufac-components/src/components/Button';
import { ShippingTypeForm } from '@iarcpsu/emanufac-components/src/components/Forms';
import { Loading } from '@iarcpsu/emanufac-components/src/components/Loading';
import { Error } from '@iarcpsu/emanufac-components/src/components/Error';
import { ViewTitle } from '@iarcpsu/emanufac-components/src/components/ViewTitle';

export default function EditShippingType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const shippingType = useSelector((state) => state.shippingType);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      type_code: shippingType.type_code,
      name: shippingType.name,
      detail: shippingType.detail,
    },
  });

  useEffect(() => {
    dispatch(actions.shippingTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      // eslint-disable-next-line no-param-reassign
      console.log(data);
      await dispatch(actions.shippingTypePut(id, data));
      alert('สำเร็จ');
      await dispatch(actions.shippingTypeGet(id));
    } catch (error) {
      console.log(error);
    }
  };
  if (shippingType.isLoading || shippingType.rows) {
    return <Loading />;
  }
  if (!shippingType.isLoading && shippingType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-6">
            <form onSubmit={handleSubmit(onSubmit)}>
              <ShippingTypeForm
                control={control}
                Controller={Controller}
                errors={errors}
                shippingType={shippingType}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditShippingType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditShippingType.defaultProps = {
  title: '',
  subtitle: '',
};
